var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoMessage"},[_c('custom-video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"src":_vm.videoSrc(),"max-width":260,"max-height":200,"playback-rates":[0.7, 1.0, 1.5, 2.0],"muted":false,"timestamp":_vm.displayTimestamp,"timestamp-tooltip":_vm.timestampTooltip}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f3678f4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/popup-chat/messages/VideoMessage.vue
// module id = AXNB
// module chunks = 0